import { Component, EventEmitter, Output } from '@angular/core';
import { AbstractDynamicReportViewComponent } from '../../abstract/abstract-dynamic-report-view.component';
import { ReportRecord } from '../../models/report.model';
import { EditableFieldsService } from '../editable-fields.service';

@Component({
  selector: 'rep-table-view',
  templateUrl: './table-view.component.html',
  providers: [EditableFieldsService],
  standalone: false,
})
export class TableViewComponent extends AbstractDynamicReportViewComponent {
  @Output() removeRecord: EventEmitter<ReportRecord> = new EventEmitter<ReportRecord>();
  @Output() reportReordered: EventEmitter<ReportRecord[]> = new EventEmitter<ReportRecord[]>();

  removeRecordFromReport(reportItem) {
    const recordId = reportItem.recordId ? reportItem.recordId : reportItem.data.recordId;
    this.removeRecord.emit({ ...reportItem, recordId });
  }
}
